<template>
    <div>
        <v-overlay :value="overlay">
        <v-progress-circular
            indeterminate
            size="64"
        ></v-progress-circular>
        </v-overlay>
        <div class="mx-5 mx-sm-10 mx-md-16 px-md-16 my-6">
            <h1 class="display-1 font-weight-bold color-title font-title"><i>Grupo Innofarm</i></h1>
            <h1 class="font-size-custom font-weight-bold color-title font-title"><i>SUS TRANSACCIONES</i></h1>
        </div>
        <div class="mx-5 mx-sm-10 mx-md-16 px-md-16 mb-8 font-text">
            <v-col cols="12">
                <v-row>
                    <v-col md="6">
                        <v-menu>
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="dateRangeText"
                                    label="Seleccionar fechas de busqueda"
                                    persistent-hint
                                    readonly
                                    append-icon="mdi-calendar-multiple"
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                range
                                v-model="dates"
                                no-title
                                @input="menu = false"
                                @change="getTransactions"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col md="6"></v-col>
                </v-row>
            </v-col>
            <v-data-table
                :headers="headers"
                :items="transactions"
                :items-per-page="itemsPerPage"
                hide-default-footer
                class="elevation-1"
                :loading="loadingTable"
                key="quote_id"
                :options.sync="options"
            >
                <template v-slot:item.action="{item}">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon 
                                color="primary"
                                v-bind="attrs"
                                v-on="on" 
                                @click="getQuoteStates(item)"
                            >
                                mdi-eye
                            </v-icon>
                        </template>
                        <span>Ver estado del pedido</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon 
                                color="secondary"
                                v-bind="attrs"
                                v-on="on" 
                                class="ml-2"
                                @click="getQuotePayments(item)"
                            >
                                mdi-cash-usd
                            </v-icon>
                        </template>
                        <span>Ver pagos del pedido</span>
                    </v-tooltip>
                    <v-tooltip bottom v-if="item.clave_acceso != null">
                        <template v-slot:activator="{ on, attrs }">
                            <a :href="`https://sufactura.ec/descargar-ride?claveAcceso=${item.clave_acceso}`" target="_blank" rel="noopener noreferrer">
                                <v-icon 
                                    color="error"
                                    v-bind="attrs"
                                    v-on="on" 
                                    class="ml-2"
                                >
                                    mdi-file-pdf
                                </v-icon>
                            </a>
                        </template>
                        <span>Descargar factura</span>
                    </v-tooltip>
                </template>
                <template v-slot:footer>
                    <v-pagination
                        class='mt-10'
                        v-model="currentPage"
                        :length="pageCount"
                        @input="getTransactions"                    
                        total-visible=10     
                    ></v-pagination>
                </template>
            </v-data-table>
        </div>
        <v-dialog
            transition="dialog-bottom-transition"
            max-width="1000"
            v-model="modalPaments"
        >
            <v-card>
                <v-toolbar color="primary" dark dense id="toolbar-payment">
                    <span  class="ml-3" > <b> PAGOS DE LA COTIZACIÓN {{ quoteId }} </b></span>
                    <span class="mr-3"><b> Total: {{ amount }} </b></span>
                </v-toolbar>
                <v-card-text>
                    <div class="text-h2 pt-9">
                        <v-data-table
                            :headers="headersPayments"
                            :items="payments"
                            class="elevation-1"
                            key="order_payment_preference_id"
                            
                        >

                        <!-- <v-data-footer>
                            <template v-slot:page-text>
                                <div>
                                     hola
                                </div>
                            </template>
                        </v-data-footer> -->
                        </v-data-table>
                    </div>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn color="default" @click="modalPaments = false">
                        <v-icon>mdi-cancel</v-icon> Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            transition="dialog-bottom-transition"
            max-width="1000"
            v-model="modalStates"
        >
            <v-card>
                <v-toolbar color="primary" dark dense id="toolbar-payment">
                    <span  class="ml-3" > <b> SEGUIMIENTO DE TU PEDIDO </b></span>
                </v-toolbar>
                <v-card-text>
                    <div class="pt-2">
                        <v-toolbar 
                                color="primary" 
                                dark 
                                dense 
                                id="toolbar-payment" 
                                class="mt-3"
                            >
                            <span class="ml-3" > <b> <v-icon>mdi-checkbox-multiple-marked-outline</v-icon> ESTADO ACTUAL DEL PEDIDO </b></span>
                        </v-toolbar>
                        <div class="mt-3">
                            <v-stepper 
                                v-if="['md','lg','xl'].includes($vuetify.breakpoint.name)"
                                alt-labels
                            >
                                <v-stepper-header>
                                    <v-stepper-step>
                                        <template v-slot:default>
                                            <v-col class="py-0 mb-3" style="position: relative;bottom: 8px;">
                                                <v-icon :color="successStep >= 1 ? 'primary' : 'default'" :class="successStep == 1 ? 'pulse' : ''">mdi-36px mdi-checkbox-multiple-marked-outline</v-icon>
                                            </v-col>
                                            <div :class="successStep >= 1 ? 'primary--text' : 'default--text'">
                                                <b> CONFIRMADO</b>
                                            </div>
                                        </template>
                                    </v-stepper-step>
                                    <v-divider></v-divider>
                                    <v-stepper-step>
                                        <template v-slot:default>
                                            <v-col class="py-0 mb-3" style="position: relative;bottom: 8px;">
                                                <v-icon :color="successStep > 1 ? 'primary' : 'default'" :class="successStep == 2 ? 'pulse' : ''">mdi-36px mdi-package-variant</v-icon>
                                            </v-col>
                                            <div :class="successStep > 1 ?  'primary--text' : 'default--text'" style="white-space: pre;">
                                                <b> EN PREPARACIÓN</b>
                                            </div>
                                        </template>
                                    </v-stepper-step>
                                    <v-divider></v-divider>
                                    <v-stepper-step>
                                        <template v-slot:default>
                                            <v-col class="py-0 mb-3" style="position: relative;bottom: 8px;">
                                                <v-icon :color="successStep > 2 ? 'primary' : 'default'" :class="successStep == 3 ? 'pulse' : ''">mdi-36px mdi-truck-fast</v-icon>
                                            </v-col>
                                            <div :class="successStep > 2 ?  'primary--text' : 'default--text'">
                                                <b> EN RUTA </b>
                                            </div>
                                        </template>
                                    </v-stepper-step>
                                    <v-divider></v-divider>
                                    <v-stepper-step>
                                        <template v-slot:default>
                                            <v-col class="py-0 mb-3" style="position: relative;bottom: 8px;">
                                                <v-icon :color="successStep > 3 ? 'primary' : 'default'" :class="successStep == 4 ? 'pulse' : ''">mdi-36px mdi-account-check</v-icon>
                                            </v-col>
                                            <div :class="successStep > 3 ?  'primary--text' : 'default--text'">
                                            <b> ENTREGADO </b>
                                            </div>
                                        </template>
                                    </v-stepper-step>
                                </v-stepper-header>
                            </v-stepper>
                            <v-stepper
                                v-if="['sm','xs'].includes($vuetify.breakpoint.name)"
                                vertical
                            >
                                    <v-stepper-step style="justify-content: space-around;">
                                        <template v-slot:default>
                                            <v-col class="py-0 mb-3" style="position: relative;bottom: 8px;">
                                                <v-icon :color="successStep >= 1 ? 'primary' : 'default'" :class="successStep == 1 ? 'pulse' : ''">mdi-36px mdi-checkbox-multiple-marked-outline</v-icon>
                                            </v-col>
                                            <div :class="successStep >= 1 ? 'primary--text' : 'default--text'">
                                                <b> CONFIRMADO</b>
                                            </div>
                                        </template>
                                    </v-stepper-step>
                                    <v-divider></v-divider>
                                    <v-stepper-step style="justify-content: space-around;">
                                        <template v-slot:default>
                                            <v-col class="py-0 mb-3" style="position: relative;bottom: 8px;">
                                                <v-icon :color="successStep > 1 ? 'primary' : 'default'" :class="successStep == 2 ? 'pulse' : ''">mdi-36px mdi-package-variant</v-icon>
                                            </v-col>
                                            <div :class="successStep > 1 ?  'primary--text' : 'default--text'" style="white-space: pre;">
                                                <b> EN PREPARACIÓN</b>
                                            </div>
                                        </template>
                                    </v-stepper-step>
                                    <v-divider></v-divider>
                                    <v-stepper-step style="justify-content: space-around;">
                                        <template v-slot:default>
                                            <v-col class="py-0 mb-3" style="position: relative;bottom: 8px;">
                                                <v-icon :color="successStep > 2 ? 'primary' : 'default'" :class="successStep == 3 ? 'pulse' : ''">mdi-36px mdi-truck-fast</v-icon>
                                            </v-col>
                                            <div :class="successStep > 2 ?  'primary--text' : 'default--text'">
                                                <b> EN RUTA </b>
                                            </div>
                                        </template>
                                    </v-stepper-step>
                                    <v-divider></v-divider>
                                    <v-stepper-step style="justify-content: space-around;">
                                        <template v-slot:default>
                                            <v-col class="py-0 mb-3" style="position: relative;bottom: 8px;">
                                                <v-icon :color="successStep > 3 ? 'primary' : 'default'" :class="successStep == 4 ? 'pulse' : ''">mdi-36px mdi-account-check</v-icon>
                                            </v-col>
                                            <div :class="successStep > 3 ?  'primary--text' : 'default--text'">
                                            <b> ENTREGADO </b>
                                            </div>
                                        </template>
                                    </v-stepper-step>
                            </v-stepper>
                        </div>
                        <div v-if="contents.length">
                            <v-toolbar 
                                color="primary" 
                                dark 
                                dense 
                                id="toolbar-payment" 
                                class="mt-3"
                            >
                            <span class="ml-3" > <b> <v-icon>mdi-paperclip</v-icon> ARCHIVOS DEL PEDIDO </b></span>
                            </v-toolbar>
                            <v-row>
                                <v-col
                                    md="4"
                                    v-for="(content, i) in contents"
                                    :key="i"
                                >
                                    <v-card tile elevation="2">
                                        <v-img
                                            :id="`item_${i}`"
                                            :src="`${domain}img/web_commerce/${content.content_name}`"
                                            class="grey darken-4"
                                        ></v-img>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn color="default" @click="modalStates = false">
                        <v-icon>mdi-cancel</v-icon> Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>   
</template>

<script>

    import {mapActions, mapMutations, mapState} from 'vuex'
    import MenuMovilComponent from '../partials/MenuMovilComponent'
    import HeaderTopComponent from '../partials/HeaderTopComponent'
    import MenuComponent from '../partials/MenuComponent'
    import FooterComponent from '../partials/FooterComponent'
    import BreadCrumbsComponent from '../partials/BreadCrumbsComponent'

    export default{
        name:  'CustomerTransactionsComponent',
        components:{
            MenuMovilComponent,
            HeaderTopComponent,
            MenuComponent,
            FooterComponent,
            BreadCrumbsComponent
        },
        data: () => ({
            options: {},
            currentPage: 1,
            pageCount: 1,
            itemsPerPage: 10,
            modalPaments:false,
            modalStates:false,
            modalstate:false,
            overlay:false,
            quoteId: null,
            successStep:0,
            menu1:false,
            quoteBalance: 0,
            amount: 0,
            transactions:[],
            dates: [],
            domain: process.env.VUE_APP_NODE_ENV === "production" ? process.env.VUE_APP_API_URL_PROD : process.env.VUE_APP_API_URL_DEVEL,
            payments:[],
            contents:[],
            headers: [
                { text: 'Compra', value: 'quote_id' },
                { text: 'Canal', value: 'channel' },
                //{ text: 'Tipo de pago', value: 'payment_type' },
                //{ text: 'Refencia', value: 'referece_id_place_to_pay' },
                { text: 'Fecha / Hora', value: 'issue_date' },
                { text: 'Total', value: 'total' },
                { text: 'Estado', value: 'status_payment' },
                //{ text: 'Autorización', value: 'payment_authorization_place_to_pay' },
                { text: 'Acciones', value: 'action' }
        
            ],
            headersPayments: [
                { text: 'Orden', value: 'order_id' },
                { text: 'Tipo de pago', value: 'payment_type' },
                { text: 'Monto', value: 'amount' },
                { text: 'Estado', value: 'payment_status' },
                { text: 'Referencia', value: 'reference' }
        
            ],
            breadcrumbs:[
                {name:'Inicio',url:'/'},
                {name:'Transacciones del cliente',url:'/transacciones'}
            ],
            
        }),
        computed: {
            ...mapState(['user','loadingTable']),

            menuMovil() {
                return this.$vuetify.breakpoint.name == "sm" || this.$vuetify.breakpoint.name == "xs"
            },

            dateRangeText () {
                return this.dates.join(' ~ ')
            },


        },
        watch:{
            options: {
                handler () {
                    this.getTransactions()
                },
                deep: true,
            },
        },
        methods: {

            ...mapMutations(["setUrl","setLoadingTable"]),

            ...mapActions(["requestApi"]),

            getTransactions(){

                this.setLoadingTable()
                this.setUrl("cotizacion-web")
                this.requestApi({
                    method: 'GET',
                    data:{
                        partyId: this.user.party_id,
                        page: this.currentPage, 
                        page_count: this.pageCount, 
                        page_size: this.itemsPerPage,
                        dates: this.dates
                    } 
                }).then(res => {
                    
                    this.transactions= res.data.data
            	    this.pageCount = res.data.page_count; 
                    this.setLoadingTable()
                    
                })

            },

            getQuotePayments(quote){
               
                this.quoteId= quote.quote_id
                this.overlay = true
                this.amount =quote.total
                this.setUrl(`cotizacion-web/${quote.quote_id}`)
                this.requestApi({
                    method: 'GET',
                    data: { 
                        typeData: 'payments'
                    } 
                }).then(res => {
                                       
                    this.payments = res.data.data
                    this.overlay = false
                    this.modalPaments = true
                    
                }).catch(err => {
                    this.overlay = false
                })

            },

            getQuoteStates(quote){

                this.quoteId= quote.quote_id
                this.overlay = true
               
                this.setUrl(`cotizacion-web/${quote.quote_id}`)
                this.requestApi({
                    method: 'GET',
                    data: { 
                        typeData: 'states'
                    } 
                }).then(res => {
                                       
                    console.log(res)
                    this.successStep = res.data.data.step
                    this.contents = res.data.data.contnets
                    this.overlay = false
                    this.modalStates = true
                    
                }).catch(err => {
                    this.overlay = false
                })

            }

        },
        created(){
            let d = new Date()
            let month = d.setMonth(d.getMonth()-1)
            let dd = new Date(month).toISOString().substr(0, 10)
            this.dates = [
                dd,
                new Date().toISOString().substr(0, 10)
            ]
        }

    }

</script>

<style>

    #toolbar-payment div.v-toolbar__content {
        justify-content: space-between;
    }

    .v-stepper__label {
        align-items: revert!important;
        text-align: center!important;
       
    }

    .v-stepper__step__step{
        display: none;
    }

    .pulse {
        animation: pulse-animation 2s infinite;
        border-radius: 50px;
    }

    .v-picker--date{
        width: 100%;
    }

    @keyframes pulse-animation {
        0% {
            box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.2);
        }
        100% {
            box-shadow: 0 0 0 20px rgba(0, 0, 0, 0);
        }
    }
</style>